module.exports = __webpack_public_path__ + "static/media/Miguel Cárdenas Hernández‎ 01.ef6cc059.jpg";